import { TaxRateDto } from 'src/api';
import { useLocales } from 'src/locales';
// type
import { SelectOption } from 'src/types/select';

type InputValue = {
  taxRates: TaxRateDto[];
};

export default function TaxSelectOptions({ taxRates }: InputValue) {
  const { t } = useLocales();

  const optionValue = (tx: TaxRateDto) =>
    `${tx.value ?? 0} % - ${tx.name ?? t('VAT')}  - ${
      tx.inclusive ? t('Inclusive') : t('Exclusive')
    }${tx.accountId ? ` - ${tx.accountId}` : ''}`;

  const optionValues: SelectOption[] = [];

  taxRates.forEach((tax, index) => {
    optionValues.push({ key: `tax-${tax.id}-${index}`, value: tax.id, children: optionValue(tax) });
  });

  return optionValues;
}
